import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { catchError, map, of } from 'rxjs';
import { TokenService } from '../services/token.service';
import { AuthService } from '../services/auth.service';

/**
 * AuthenGuard — ทำงานทุกหน้าที่ต้อง login
 * 1. เช็ค token มีอยู่และยังไม่หมดอายุ
 * 2. ยิง loadUserProfile() (มี cache 5 วินาที) เพื่อเช็คกับ server
 *    - ถ้า 401 → interceptor จะลอง refresh token ให้อัตโนมัติ
 *    - ถ้า refresh ก็ไม่ได้ → signout + redirect
 * 3. ถ้าสำเร็จ → ผ่าน guard
 */
export const authGuard: CanActivateFn = (_route, state) => {
  const token   = inject(TokenService);
  const authSvc = inject(AuthService);
  const router  = inject(Router);

  if (!token.getAccessToken()) {
    return redirectToLogin(router, state.url);
  }

  // ยิง loadUserProfile เพื่อเช็คว่า token ยังใช้ได้
  // interceptor จะ handle refresh token ถ้า 401
  return authSvc.loadUserProfile().pipe(
    map(() => true),
    catchError(() => {
      // refresh ไม่ได้ → ถูก signout แล้วจาก interceptor
      return of(redirectToLogin(router, state.url));
    }),
  );
};

function redirectToLogin(router: Router, returnUrl: string) {
  const role = returnUrl.startsWith('/bidder') ? 'bidder' : 'owner';
  if (role === 'owner') {
    return router.createUrlTree(['/owner/account'], { queryParams: { returnUrl } });
  }
  return router.createUrlTree(['/'], { queryParams: { openLogin: true, returnUrl } });
}
